// Tremor Raw Card [v0.0.0]
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cx } from "../../lib/utils";
const Card = React.forwardRef((_a, forwardedRef) => {
    var { className, asChild } = _a, props = __rest(_a, ["className", "asChild"]);
    const Component = asChild ? Slot : "div";
    return (React.createElement(Component, Object.assign({ ref: forwardedRef, className: cx(
        // base
        "onvo-relative onvo-w-full onvo-rounded-2xl onvo-border-solid onvo-border onvo-p-6 onvo-text-left onvo-shadow-sm", 
        // background color
        " onvo-bg-white dark:onvo-bg-[#090E1A]", 
        // border color
        "onvo-border-black/5 dark:onvo-border-white/10", className) }, props)));
});
Card.displayName = "Card";
export { Card };
//# sourceMappingURL=Card.js.map